/**
 * 본문 제목의 번호와 앵커 id. 나무위키처럼 번호로 만든다.
 *
 *   h2 → `1.` 번호, id `s-1`
 *   h3 → 번호 없음, id `s-1.2` (속한 절 번호 + 순번)
 *
 * 제목 글자로 id 를 만들면 한글이 주소창에서 `#%EB%82%B4…` 로 길게 인코딩되고,
 * 같은 제목이 두 번 나오면 중복 처리도 따로 해야 한다. 번호는 짧고 겹치지 않는다.
 *
 * 저장하지 않고 렌더할 때 매긴다 — 절을 끼워 넣거나 옮겨도 고칠 일이 없다. 대신
 * 절 순서가 바뀌면 공유된 `#s-3` 이 다른 절을 가리킬 수 있다(나무위키도 같다).
 * 문서 하나를 그리는 동안만 유효하므로 렌더마다 새로 만든다.
 */
export function createHeadingAnchors() {
  let section = 0;
  let sub = 0;

  return {
    /** 다음 절(h2). 하위 순번은 0 으로 돌아간다. */
    section(): { number: number; id: string } {
      section += 1;
      sub = 0;
      return { number: section, id: `s-${section}` };
    },
    /** 지금 절 아래 다음 소제목(h3)의 id. 첫 절 앞의 h3 는 `s-0.n`. */
    sub(): string {
      sub += 1;
      return `s-${section}.${sub}`;
    },
  };
}

export type HeadingAnchors = ReturnType<typeof createHeadingAnchors>;
